import client from '../config/AxiosConfig';

export const GetPoints = async () => await client.get(`/points`);

export const GetPointsItem = async (id) => await client.get(`/points/${id}`);

export const UpdatePoints = async (id, data) => await client.put(`/points/${id}`, data);